import {MyopMessages} from "../../common/MyopMessages";
import {myopAttributes} from "../../consts";
import {BaseMessageHandler, IElementRef, MyopElementRef} from "../../common";
import {DetectedMyopRefsMessage, DetectMyopRefsMessage} from "../../messages";

export class DetectMyopRefsMessageHandler extends BaseMessageHandler<DetectMyopRefsMessage> {

    messageType = MyopMessages.DetectMyopRefsMessage;

    executor = (message: DetectMyopRefsMessage) => {
        const allMyopItems = document.querySelectorAll(`[${myopAttributes.id}]`);
        //const allMyopItems = document.querySelectorAll(`*`);

        let myopRefs: IElementRef[] = [];

        //let counters: Record<string, number> = {};

        allMyopItems.forEach(item => {

            const myopId = item.getAttribute(myopAttributes.id);
            if (myopId) {
                myopRefs.push(new MyopElementRef(myopId, item.tagName, item.getBoundingClientRect()))
            } //else {
            //     if (!counters[item.tagName]) {
            //         counters[item.tagName] = 0;
            //     }
            //     counters[item.tagName] = counters[item.tagName] + 1;
            //
            //     myopRefs.push(new XPathElementRef(`${item.tagName}(${counters[item.tagName]})`, item.tagName, item.getBoundingClientRect()))
            // }
        })

        this.messageToHost(new DetectedMyopRefsMessage(message.handlerUniqueId, myopRefs))
    }
}
